import { useEffect, useState } from "react";
import { collection, getDocs, orderBy, query } from "firebase/firestore";
import { db } from "../firebase";
import { BlogPost } from "../types";

let cachedPosts: BlogPost[] | null = null;

export function usePosts() {
  const [posts, setPosts] = useState<BlogPost[]>(cachedPosts ?? []);
  const [loading, setLoading] = useState(!cachedPosts);

  useEffect(() => {
    if (cachedPosts) return;

    getDocs(query(collection(db, "posts"), orderBy("date", "desc")))
      .then((snap) => {
        const data = snap.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        })) as BlogPost[];
        cachedPosts = data;
        setPosts(data);
      })
      .finally(() => setLoading(false));
  }, []);

  return { posts, loading };
}
